import { Alert, Grid, Typography } from "@mui/material";
import { useCallback, useContext, useMemo } from "react";

import { HeavyCard } from "../../../components/heavy-card";
import { useQuestionState } from "./question.context";
import { ItemLabel } from "../../../components/item-label";
import { RenderHtml } from "../../../components/render-html";
import { QuestionMux } from "../../../question-types/question-mux";
import { ApiIQuestion } from "../../../domain/election";

export interface QuestionVotePageProps<V = any> {
  question: ApiIQuestion;
}
export const QuestionVotePage = ({ question }: QuestionVotePageProps) => {
  const [questionState, setQuestionState] = useQuestionState(question.id);

  const { invalid_reasons } = questionState;


  const ballotVote = useMemo(() => {
    if (questionState && questionState.value && questionState.response_type === question.response_type) {
      return questionState.value;
    }

  }, [questionState, question.response_type])


  return (
    <Grid container spacing={5}>
      <Grid item xs={12}>
        <HeavyCard color={questionState.valid ? undefined : "error"}>
          <ItemLabel label={question.label} required={question.required} variant="h6" />
          <hr />

          <RenderHtml html={question.short_description} />

          <QuestionMux question={question} questionState={questionState} setQuestionState={setQuestionState} />
          {
            invalid_reasons ? invalid_reasons.filter(r => r.target === undefined).map((r, i) => <Alert key={i} severity="error" >{r.reason}</Alert>) : null
          }
        </HeavyCard>
      </Grid>
    </Grid>
  );
};